import { PencilSimple, Plus } from '@phosphor-icons/react';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { IContact, IContactForm, IContactGroup } from 'contacts/types';
import { Button } from 'core/components';
import { Color } from 'theme/enums';

import { UpsertContact } from './UpsertContact';

interface IProps {
  contact?: IContact;
  contactGroup?: Partial<IContactGroup>;
  onSubmitSuccess?: (contact: IContact, contactGroup?: IContactGroup) => void;
  initialValues?: Partial<IContactForm>;
  level?: number;
  disabled?: boolean;
}

export const UpsertContactButton = ({
  contact,
  contactGroup,
  onSubmitSuccess,
  initialValues,
  level,
  disabled,
}: IProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const { t } = useTranslation();

  const isEdit = useMemo(() => !!contact?.id, [contact]);

  return (
    <>
      <Button
        text={isEdit ? t('buttonLabelEdit') : t('buttonLabelAddContact')}
        color={isEdit ? Color.PRIMARY : Color.SUCCESS}
        startDecorator={isEdit ? <PencilSimple /> : <Plus />}
        onClick={() => setIsOpen(true)}
        disabled={disabled}
      />

      <UpsertContact
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        contact={contact}
        contactGroup={contactGroup}
        onSubmitSuccess={onSubmitSuccess}
        initialValues={initialValues}
        level={level}
      />
    </>
  );
};
